import httpClient from "../http/http-client";
import { ISrsFigures, ISrsGenerateResponse, ISrsReport, ISrsStructure } from './srs-report.model';

export default class SrsReportService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(): Promise<ISrsReport[]> {
    return this.http.get('srs-report')
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async getStructure(): Promise<ISrsStructure> {
    return this.http.get('srs-report/structure')
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async getOne(id: string): Promise<ISrsReport> {
    return this.http.get(`srs-report/${id}`)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async create(reportPeriodId: string): Promise<ISrsReport> {
    return this.http.post('srs-report', { reportPeriodId })
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async update(id: string, details: Partial<ISrsReport>): Promise<ISrsReport> {
    return this.http.patch(`srs-report/${id}`, sanitiseSrsPayload(details))
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async remove(id: string): Promise<void> {
    return this.http.delete(`srs-report/${id}`)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async getFigures(id: string): Promise<ISrsFigures> {
    return this.http.get(`srs-report/${id}/figures`)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async generate(id: string): Promise<ISrsGenerateResponse> {
    return this.http.post(`srs-report/${id}/generate`, {})
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async share(id: string): Promise<{ success: boolean, shareId: string }> {
    return this.http.post(`srs-report/${id}/share`, {})
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async unshare(id: string): Promise<void> {
    return this.http.delete(`srs-report/${id}/share`)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }
}

/**
 * Formik-style state initialises id and date fields to '', and '' in a Postgres UUID or date column
 * is an error, not an empty value. Normalise to null on the way out.
 */
const ID_AND_DATE_FIELDS = [
  'reportPeriodId',
  'signOffDate',
]

function sanitiseSrsPayload<T extends Record<string, any>>(payload: T): T {
  const cleaned: Record<string, any> = { ...payload }
  for (const field of ID_AND_DATE_FIELDS) {
    if (cleaned[field] === '') cleaned[field] = null
  }
  return cleaned as T
}
